// extracted by mini-css-extract-plugin
export var container = "styles-module--container--dbbe3";
export var info = "styles-module--info--6c8ed";
export var star = "styles-module--star--148cb";
export var stars = "styles-module--stars--d883b";
export var title = "styles-module--title--411ec";